module.exports = __webpack_public_path__ + "2a28d00883d366a4b3158f04cb677977.png";